export default __webpack_public_path__ + "static/media/Db1.6a1fd454.mp3";